import React, { useState } from 'react';

const Result = ({ currentData, index }) => {
  const getDate = (unix) => {
    const milliseconds = unix * 1000;
    const dateObject = new Date(milliseconds);
    const humanDateFormat = dateObject.toLocaleString();

    return humanDateFormat;
  };

  const formatMsrp = (val) => {
    const num = parseInt(val);
    const formattedMsrp = num.toLocaleString();

    return `$${formattedMsrp}`;
  };

  const getMinMaxWeight = (vals) => {
    const thisMin = Math.min(...vals);
    const thisMax = Math.max(...vals);

    return `${thisMin} to ${thisMax}`;
  };

  const getMinMaxLength = (vals) => {
    if (!vals.length) return;

    const thisMin = Math.min(...vals);
    const thisMax = Math.max(...vals);

    return `${thisMin} to ${thisMax}`;
  };

  return (
    <div className="node__content">
      <a
        href={`https://www.burrisoptics.com/node/${currentData[index].nid}`}
        className="node--view-mode-card--image"
      >
        <img src={currentData[index].image} alt="" />
      </a>

      <a href={`https://www.burrisoptics.com/node/${currentData[index].nid}`}>
        <div className="details">
          <h3>
            <span>{currentData[index].title}</span>
          </h3>
          <div className="msrp">
            MSRP Starting at {formatMsrp(currentData[index].msrp.min)}
          </div>
          <span className="details-link">
            <span>
              View Details
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 256 512"
              >
                <path d="M118.6 105.4l128 127.1C252.9 239.6 256 247.8 256 255.1s-3.125 16.38-9.375 22.63l-128 127.1c-9.156 9.156-22.91 11.9-34.88 6.943S64 396.9 64 383.1V128c0-12.94 7.781-24.62 19.75-29.58S109.5 96.23 118.6 105.4z" />
              </svg>
            </span>
          </span>
          <div className="dev">
            <div>status: {currentData[index].status}</div>
            <div>created: {getDate(currentData[index].created)}</div>
            <div>
              field_msrp: {formatMsrp(currentData[index].msrp.min)} -{' '}
              {formatMsrp(currentData[index].msrp.max)}
            </div>
            <div>
              field_weight:{' '}
              {getMinMaxWeight(currentData[index].value.field_weight)}
            </div>
            <div>
              field_length:{' '}
              {getMinMaxLength(currentData[index].value.field_length)}
            </div>
            <div>
              field_magnification:{' '}
              {currentData[index].value.field_magnification}
            </div>
            <div>
              field_product_family:{' '}
              {currentData[index].value.field_product_family}
            </div>
            <div>
              field_custom_knobs:{' '}
              {currentData[index].value.field_custom_knobs_term}
            </div>
            <div>
              field_illumination: {currentData[index].value.field_illumination}
            </div>
            <div>
              field_reticles:{' '}
              {currentData[index].value.field_reticles.toString()}
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default Result;
